import { request } from "./api";

export function getBlockList() {
  return request({
    url: "http://api2.tetuijiudian.com/book/book_block_promotions_hotel/getBlockList",
    method: "GET",
  });
}


